// The agent's own three questions, in the reader's language when that one is filled in.
export function resolveExampleQuestions({
	base,
	translated,
}: {
	base?: readonly string[] | null
	translated?: readonly string[] | null
}): string[] {
	const source = translated?.length ? translated : (base ?? [])

	return source
		.map((question) => question.trim())
		.filter(Boolean)
		.slice(0, 3)
}
